module.exports = __webpack_public_path__ + "static/img/young.7c1f7e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/young.png
// module id = L2Tp
// module chunks = 1